import React from "react";
import { Link } from "react-router-dom";

export default function BusinessListItem({ item, translate }) {

    

    return <div id={"promotion-" + item.id} className="offers-list__offer-item">
        <div className="offers-list__block business">
            <span className="offers-list__label offers-list__label_icon">{item.solution_topic && item.solution_topic.title}</span>
            <div className="offers-list__counter">

            </div>
            <div className="offers-list__img business">
                <img src={item.img} />
            </div>
            <h2 className="offers-list__title">
                {item.title}
            </h2>
            <div className="offers-list__text inner-html" dangerouslySetInnerHTML={{ __html: item.description }} />
            {(item.solution_type_id === '1')
                && (
                    <React.Fragment>
                        <div className="offers-list__button">
                            <Link
                                to={{
                                    pathname: "/applications/create",
                                    search: `?specialOffer=${item.title}&title=${"business"}`,
                                    state: { from: 'business', id: item.id }
                                }}
                                className="btn btn_orange"
                            >{translate('отправить заявку')}</Link>
                        </div>
                    </React.Fragment>
                )}
        </div>
    </div>
}